import { render, staticRenderFns } from "./CompanyEditForm.vue?vue&type=template&id=a9b0fab4&"
import script from "./CompanyEditForm.vue?vue&type=script&lang=js&"
export * from "./CompanyEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports